export default "__VITE_ASSET__BOw0TSIm__"